import {Button, Drawer, message, Space} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import {useGetCustomerStoreServicesOrdersContext} from "../../../../../../../service-feature/useCases/get-orders/context/customer";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {Controller, useForm} from "react-hook-form";
import TextArea from "antd/lib/input/TextArea";
import {yupResolver} from "@hookform/resolvers/yup";
import yup from "../../../../../../../utils/yup-extended";
import {useCustomerStoreServiceOrderRequestRevisionApi} from "../../../../../../../react-query-hooks/store/services/store-service-request-revision";
import {StyledStoreServiceOrderDrawer} from "../styles";

export const storeServiceCustomerReviewRequestSchema = yup.object().shape({
  customerComment: yup.string().trim().required("Leave a comment"),
});

export function CustomerStoreServiceOrderRevisionRequestDrawer() {
  const {
    state: {selectedStoreServiceOrderInfo, activeStoreServiceOrderDrawer},
    dispatch,
  } = useGetCustomerStoreServicesOrdersContext();
  const customerStoreServiceOrderRequestRevisionApi =
    useCustomerStoreServiceOrderRequestRevisionApi();

  const {
    control,
    formState: {errors},
    watch,
    handleSubmit,
    reset,
  } = useForm<{
    customerComment: string;
  }>({
    resolver: yupResolver(storeServiceCustomerReviewRequestSchema),
    mode: "onSubmit",
    defaultValues: {
      customerComment: "",
    },
  });

  if (!selectedStoreServiceOrderInfo) return null; // or show a loader/skeleton
  const onOrderInfoDrawerClose = () => {
    reset();
    dispatch({
      type: "set-active-store-service-order-drawer",
      payload: "order-info",
    });
  };
  const onSubmit = (values: {customerComment: string}) => {
    // console.log({values});

    customerStoreServiceOrderRequestRevisionApi.mutate(
      {
        orderId: selectedStoreServiceOrderInfo.order.id,
        reason: values.customerComment,
      },
      {
        onSuccess() {
          message.success("Revision requested successfully!");
          onOrderInfoDrawerClose();
          dispatch({
            type: "update-status-id",
            payload: 4,
          });
        },
      }
    );
  };
  return (
    <StyledStoreServiceOrderDrawer
      title={selectedStoreServiceOrderInfo.productService.name}
      placement="right"
      onClose={onOrderInfoDrawerClose}
      visible={activeStoreServiceOrderDrawer === "request-review"}
      closable={false}
      extra={
        <Button size="small" type="text" onClick={onOrderInfoDrawerClose}>
          <CloseOutlined />
        </Button>
      }
    >
      <div>
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <Space size={24} direction="vertical" style={{display: "flex"}}>
            <FormField
              id="customerComment"
              label="You can request a revision once if the delivery doesn’t meet your
              expectations. Please describe what needs to be improved."
              renderInput={(id) => (
                <Controller
                  control={control}
                  name="customerComment"
                  render={({
                    field: {onChange, value, ref, onBlur},
                    fieldState: {error},
                  }) => (
                    <Space size={8} direction="vertical" style={{display: "flex"}}>
                      <TextArea
                        id={id}
                        status={error?.message ? "error" : ""}
                        onChange={onChange}
                        onBlur={onBlur}
                        size="large"
                        value={value === null ? undefined : value}
                        placeholder="Let the creator know what needs to be changed"
                        ref={ref}
                      />
                      <FormFieldError errorMessage={error?.message} />
                    </Space>
                  )}
                />
              )}
            />
            <div>
              <Button
                disabled={
                  Object.keys(errors).length > 0 || Object.values(watch()).length < 1
                }
                loading={customerStoreServiceOrderRequestRevisionApi.isLoading}
                htmlType="submit"
                size="small"
                type="primary"
              >
                Send revision request
              </Button>
            </div>
          </Space>
        </form>
      </div>
    </StyledStoreServiceOrderDrawer>
  );
}
